var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar1212 = function SvgStar1212(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB800",
    d: "M5.681 1.208a.348.348 0 0 1 .638 0l1.243 2.64c.07.143.2.243.352.267l.004.001 2.777.423c.292.044.408.42.197.635l-2.01 2.052a.51.51 0 0 0-.136.436v.004l.475 2.898c.05.304-.255.536-.516.392l-.21-.115-.003-.002L6.22 9.59a.46.46 0 0 0-.44 0l-2.272 1.25-.002.002-.21.115c-.262.144-.566-.088-.517-.392l.04-.245.001-.003.434-2.65a.51.51 0 0 0-.136-.44L1.28 5.35l-.003-.002-.17-.173c-.21-.216-.094-.59.198-.635l2.78-.423a.48.48 0 0 0 .354-.272l1.136-2.41.001-.003z"
  })));
};
export default SvgStar1212;